import ServerErrorAlert from 'adapter/in/dashboards/components/ServerErrorAlert';
import React from 'react';
import { Grid, Cell, Row, Paragraph, Button } from '@dexma/ui-components';
import i18n from 'asset/translation';
import gtmIds from 'adapter/in/dashboards/config/gtm';
import { StyledPinDashboardModal } from 'adapter/in/dashboards/pages/Modals/PinModal/style';

const gtm = gtmIds.dashboard.pinModal;

export type PinDashboardModalProps = {
    error: boolean;
    isLoading: boolean;
    isReplacing: boolean;
    showModal: boolean;
    onClose: () => void;
    onPin: () => void;
    isUnpinning?: boolean;
};

const PinDashboardModal = (props: PinDashboardModalProps) => {
    const { onPin, showModal, onClose, error, isLoading, isReplacing, isUnpinning } = props;

    const confirmButtonText = () => {
        if (isUnpinning) return i18n.t('dashboards.pinned.action.unpinShort');
        return isReplacing ? i18n.t('common.replace') : i18n.t('dashboards.pinned.action.pin');
    };

    const bodyText = () => {
        if (isUnpinning) return i18n.t('dashboards.pinned.modal.unpin.body');
        return isReplacing ? i18n.t('dashboards.pinned.modal.replace.body') : i18n.t('dashboards.pinned.modal.pin.body');
    };

    const titleText = () => {
        if (isUnpinning) return i18n.t('dashboards.pinned.modal.unpin.title');
        return isReplacing ? i18n.t('dashboards.pinned.modal.replace.title') : i18n.t('dashboards.pinned.modal.pin.title');
    };

    return (
        <StyledPinDashboardModal
            width={450}
            visible={showModal}
            onCancel={onClose}
            title={titleText()}
            data-testid={isReplacing ? 'replace-dashboard-modal' : 'pin-dashboard-modal'}
        >
            <Grid fluid className='no-padding-grid'>
                <Row>
                    {error && (
                        <Cell>
                            <ServerErrorAlert tryAgain={() => onPin()} dataId={`${gtm.actions.tryAgain}`} />
                        </Cell>
                    )}
                </Row>
                <Row>
                    <Cell>
                        <Paragraph data-testid='pin-message' margin='0 40px 0 0'>
                            {bodyText()}
                        </Paragraph>
                    </Cell>
                </Row>
                <div className='buttons'>
                    <Button
                        variant={isUnpinning ? 'destructive' : 'primary'}
                        text={confirmButtonText()}
                        data-testid='pin'
                        isLoading={isLoading}
                        onClick={isLoading ? undefined : () => onPin()}
                        dataId={gtm.actions.pin}
                    />
                    <Button
                        className='cancel'
                        variant='secondary'
                        text={i18n.t('common.cancel')}
                        type='button'
                        data-testid='cancel'
                        onClick={() => {
                            onClose();
                        }}
                        dataId={gtm.actions.cancel}
                    />
                </div>
            </Grid>
        </StyledPinDashboardModal>
    );
};

export default PinDashboardModal;
